module.exports = __webpack_public_path__ + "media/logos/logo_laureat_2019-6c85ed4d.png";